import {
  SourceFreshnessTestResult,
  TestResult,
} from '@elementary/common-ui/types';
import SourceFreshnessExpandedRow from '@/shared/components/AlertDetails/SourceFreshnessExpandedRow';
import useReport from '@/shared/hooks/useReport';
import AnomalyDetectionExpandedRow from './AnomalyDetectionExpandedRow';
import DbtExpandedRow from './DbtExpandedRow';
import ErrorExpandedRow from './ErrorExpandedRow';
import SchemaChangesExpandedRow from './SchemaChangesExpandedRow';

type Props = {
  rowData: TestResult | SourceFreshnessTestResult;
  showWidgetButtons: boolean;
};

const AlertDetails = ({ rowData, showWidgetButtons }: Props) => {
  const { reportData } = useReport();

  if (rowData?.metadata.latest_run_status === 'error') {
    return (
      <ErrorExpandedRow
        rowData={rowData as TestResult}
        showWidgetButtons={showWidgetButtons}
      />
    );
  }
  if (
    rowData?.metadata.test_type === 'anomaly_detection' ||
    rowData?.metadata.test_type === 'elementary_cloud'
  ) {
    return (
      <AnomalyDetectionExpandedRow
        rowData={rowData as TestResult}
        reportData={reportData}
        showWidgetButtons={showWidgetButtons}
      />
    );
  }
  if (rowData?.metadata.test_type === 'schema_change') {
    return (
      <SchemaChangesExpandedRow
        rowData={rowData as TestResult}
        showWidgetButtons={showWidgetButtons}
      />
    );
  }

  if (rowData?.metadata.test_type === 'dbt_test') {
    return (
      <DbtExpandedRow
        rowData={rowData as TestResult}
        showWidgetButtons={showWidgetButtons}
      />
    );
  }
  if (rowData?.metadata.test_type === 'source_freshness') {
    return (
      <SourceFreshnessExpandedRow
        rowData={rowData as SourceFreshnessTestResult}
        showWidgetButtons={showWidgetButtons}
      />
    );
  }
  return null;
};

export default AlertDetails;
